import React, { Component } from 'react'
import '../assets/notfound.css'

class NotFoundPage extends Component{
  render() {
    return(
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404">
            <h1>404</h1>
          </div>
          <h2>Oops! Nothing was found</h2>
          <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
          <p><a href="#">Go To GERP</a></p>
        </div>
      </div>
    );
  }
}

export default NotFoundPage;
